import { action, computed, observable } from 'mobx';

import { events } from '@estee/elc-service-bus';
import { ViewController } from '@estee/elc-service';
import { ICart } from '@estee/elc-service-bus/typings/src/service-bus-topics/events/CartInterfaces';

import IOffer from '~domain/entities/Offer/IOffer';
import Offer from '~domain/entities/Offer/Offer';
import {
    IOffersViewController,
    IOffersViewControllerData
} from '~exported/cart-sidebar-cart-offers/OffersViewController/IOffersViewController';
import { OfferActionsEnum } from '~utils/OffersEnum';
import UpdateOfferUseCase from '~use-cases/UpdateOfferUseCase';
import OffersRepository from '~repositories/OffersRepository/OffersRepository';
import { eventEmitter } from '~sharedComponents/EventAdapters';

export class OffersViewController extends ViewController implements IOffersViewController {
    @observable offersRepository: OffersRepository;
    @observable currentApplyingOffers: string | null = null;

    constructor({ offersRepository }: IOffersViewController) {
        super();
        this.offersRepository = offersRepository;
        this.offersRepository.setEnabledViews([
            Offer.appliedOffers,
            Offer.cartOffersInCartView,
            Offer.cartOffersNotQualifiedView,
            Offer.cartOffersQualifiedView
        ]);
    }

    @computed
    public get data(): IOffersViewControllerData {
        const hasQualifiedInOffersTab =
            this.offersRepository.cartOffers.offersTabQualifiedCount() > 0;

        return {
            qualifiedOffers: this.qualifiedOffers,
            notQualifiedOffers: this.notQualifiedOffers,
            inCartOffers: this.inCartOffers,
            hasQualifiedInOffersTab
        };
    }

    @computed
    public get qualifiedOffers() {
        return this.offersRepository.cartOffers.qualifiedOffers;
    }

    @computed
    public get notQualifiedOffers() {
        return this.offersRepository.cartOffers.notQualifiedOffers;
    }

    @computed
    public get inCartOffers() {
        return this.offersRepository.cartOffers.inCartOffers;
    }

    @action
    public updateOfferByOfferCode = (
        offerCode: IOffer['offerCode'],
        updateAction: OfferActionsEnum
    ) =>
        new UpdateOfferUseCase({ offerCode, action: updateAction }).execute().then((res) => {
            if (res) {
                eventEmitter(events.CART_UPDATED, {} as ICart);
                this.fetchAllViews();
            }
        });

    @action
    public fetchAllViews = () => this.offersRepository.fetchAllViews();
}
